<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="区域" prop="shareOrganizationName">
              <el-input
                v-model="searchForm.shareOrganizationName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="shareCustomerName">
              <el-input
                v-model="searchForm.shareCustomerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店" prop="shareStoreName">
              <el-input
                v-model="searchForm.shareStoreName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员" prop="shareUserName">
              <el-input
                v-model="searchForm.shareUserName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="userName">
              <el-input
                v-model="searchForm.userName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="userPhone">
              <el-input
                v-model="searchForm.userPhone"
                clearable
                placeholder="请输入"
                type="number"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="活动状态" prop="status">
              <el-select v-model="searchForm.status" size="small" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="活动名称" prop="activityName">
              <el-input  v-model="searchForm.activityName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动id" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                placeholder="请输入"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商经营状态" prop="businessNature">
              <el-select v-model="searchForm.businessNature" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="钱包类型" prop="activityType">
              <el-select v-model="searchForm.activityType"  clearable @change="onSearch">
                <el-option v-for="item in activityTypeStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="参与时间"
              prop="updatedTime"
            >
              <q-date-picker startFiled="createdTimeStart" endFiled="createdTimeEnd" v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleWriteOff">核销选择订单</el-button>
          <el-button type="primary" size="small" @click="writeoffAllOrder">核销所有订单</el-button>
          <el-button type="primary" size="small" @click="jumpWriteOffRecord">核销记录</el-button>
          <div class="tips">经销商（主要岗位：经销商）＞ 经销商（主要岗位：经理，无门店）>   经销商角色（主要岗位：经理）>  分享门店店长 >   分享门店职员 > 其他门店店长 >其他门店职员</div>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="multipleTable"
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          border
          :height="maxTableHeight"
          @selection-change="handleSelectionChange"
        >
          <el-table-column  type="selection" width="55"></el-table-column>
          <el-table-column prop="userName" label="用户名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userPhone" label="联系方式" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdTime" label="参与时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityId" label="活动id" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityType" label="钱包类型" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="金额(元)" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shareOrganizationName" label="分享区域" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shareCustomerName" label="分享经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="businessNature" label="经销商经营状态" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column  prop="shareStoreName"  label="分享门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shareUserName" label="分享职员"  align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        shareOrganizationName:'',
        shareCustomerName:'',
        shareStoreName: "",
        shareUserName: "",
        userName: "",
        userPhone: "",
        activityName: "",
        activityId: "",
        createdTimeStart: "",
        createdTimeEnd: "",
        businessNature: "",
        activityType: ""
      },
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: '正常营业', label: '正常营业'},
        {value: '预停业', label: '预停业'},
        {value: '已停业', label: '已停业'},
        {value: '预营业', label: '预营业'},
        {value: '未开业停用', label: '未开业停用'},
        {value: '经营异常', label: '经营异常'},
      ],
      activityTypeStatus: [
        {value: '', label: '全部'},
        {value: '1', label: '老活动'},
        {value: '2', label: '新活动'},
      ],
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      ordArr: []
    };
  },
  methods: {
    init() {
      this.onSearch()
      // this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryNotVerificationList(params)
        .then(({ data: { list, total } }) => {
         
          this.tableData = list || [];
          this.total = total;
          // setTimeout(()=> {
          //   this.tableData.forEach((row) => {
          //     this.$refs.multipleTable.toggleRowSelection(row, true);
          //   });
          // },1000)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createdTimeStart = ''
      this.searchForm.createdTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    handleWriteOff() {
      if (!this.ordArr.length) {
        this.$message.error('请先选择需要核销的订单')
        return
      }
      this.$api.dataReport.verificationChecked({joinLogIds: this.ordArr})
        .then(res => {
          if (res.success) {
            this.$message.success('核销成功')
             this.init();
          }
        })
    },
    handleSelectionChange(arr) {
      this.ordArr = []
      arr.forEach(item => {
        this.ordArr.push(item.joinLogId)
      });
    },
    writeoffAllOrder() {
      if (!this.tableData.length) {
        this.$message.error('暂时没有要核销的订单')
        return 
      }
       this.$confirm('确认要核销所有订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.dataReport.verificationQueryResultOrder(this.filterParam)
            .then(res => {
              if (res.success) {
                this.$message.success('核销成功')
                this.init();
              }
            })
        })
    },
    jumpWriteOffRecord() {
      this.openSubPage({path: 'writeoff-record'})
    }
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
  .tips {
    margin-top: 10px;
  }

</style>
